import React from 'react';
import { Link } from '../../PlatformFunctionality';
import { styles } from './DeliveryInformation.css';
import { MarkdownBlock } from '../../MarkdownBlock';
import { BaseContentSection, CarrierInformation } from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { ImportantTextBlock } from '../ImportantTextBlock';

export type DeliveryInformationProps = {
  carrier: CarrierInformation;
  trackingUrl?: string;
  consignmentNumber?: string;
  deliveryInstruction?: string;
  footerContent?: BaseContentSection;
  importantText?: BaseContentSection;
  confirmationText?: BaseContentSection;
};

type DeliveryInformationFooterProps = {
  deliveryInstruction?: string;
  footerContent?: BaseContentSection;
};

const DeliveryInformationFooter = ({ deliveryInstruction, footerContent }: DeliveryInformationFooterProps) => {
  if (deliveryInstruction)
    return (
      <div className={styles.deliveryInstruction}>
        <p>Delivery instruction</p>
        {deliveryInstruction}
      </div>
    );
  if (footerContent)
    return (
      <div className={styles.footer}>
        {footerContent.heading ? <div className={styles.footerHeader}>{footerContent.heading}</div> : null}
        {footerContent.content ? <MarkdownBlock shouldLinkOpenInNewTab>{footerContent.content}</MarkdownBlock> : null}
      </div>
    );
  return null;
};

type DeliveryInformationTrackingBlockProps = {
  trackingUrl?: string;
  trackingNumber?: string;
  confirmationText?: string;
};

const DeliveryInformationTrackingBlock = ({
  trackingUrl,
  trackingNumber,
  confirmationText,
}: DeliveryInformationTrackingBlockProps) => {
  return (
    <div role="paragraph" className={styles.trackingLink}>
      {trackingUrl && trackingNumber ? (
        <>
          Tracking{' '}
          <Link href={trackingUrl} target="_blank" rel="noreferrer">
            #{trackingNumber}
            <Icon name="ExternalLink" className={styles.linkIcon} />
          </Link>
        </>
      ) : (
        confirmationText
      )}
    </div>
  );
};

export const DeliveryInformation = ({
  carrier,
  trackingUrl,
  consignmentNumber,
  deliveryInstruction,
  footerContent,
  importantText,
  confirmationText,
}: DeliveryInformationProps) => {
  return (
    <div data-testid="order-tracking-delivery-information" className={styles.container}>
      <div className={styles.header}>
        <div role="paragraph" className={styles.carrierName}>
          {carrier?.imageUrl ? <img className={styles.carrierLogo} alt={carrier.name} src={carrier?.imageUrl} /> : null}
          {carrier?.name ? carrier.name : 'No carrier yet'}
        </div>
        <DeliveryInformationTrackingBlock
          trackingUrl={trackingUrl}
          trackingNumber={consignmentNumber}
          confirmationText={confirmationText?.content}
        />
      </div>
      {importantText ? <ImportantTextBlock {...importantText} /> : null}
      <DeliveryInformationFooter deliveryInstruction={deliveryInstruction} footerContent={footerContent} />
    </div>
  );
};
